/**
 * 厅战结果弹窗
 */

import React from 'react';
import styled from 'styled-components';
import cls from 'classnames';
import { UiModal } from '@/components';
import { utils } from '@/lib';

const PopupResult = (props) => {
  const { item } = props;
  const { result, pkCamps } = item;
  const [left = {}, right = {}] = pkCamps;

  const resultFlag = ['same', 'win', 'fail'][result || 0];

  return (
    <Wrap {...props} isShowFooter={false}>
      <p
        className="btn-close iconfont icon-close-line"
        onClick={props.onClose}
      />
      <h6 className={cls('result-flag', `result-flag-${resultFlag}`)} />
      <ul className="pk-user">
        <li className="pk-user-item">
          <img className="avatar" src={left.pic} />
          <p className="nick text-overflow">{left.nickname || '队伍'}</p>
          <span className="value">{utils.formatNum(left.score)}</span>
        </li>
        <li className="pk-user-item">
          <img className="avatar" src={right.pic} />
          <p className="nick text-overflow">{right.nickname || '队伍'}</p>
          <span className="value">{utils.formatNum(right.score)}</span>
        </li>
      </ul>
    </Wrap>
  );
};

const Wrap = styled(UiModal)`
  color: #fff;

  .inner {
    width: 400px;
    height: 240px;
    border-radius: 8px;
    background: url(${require('../images/client/bg-result-popup.png')})
      no-repeat center / contain !important;
  }
  .ui-modal-header {
    border-bottom: 0;
  }
  .ui-modal-body {
    padding-top: 6px;
    min-width: auto;
  }
  .modal-title {
    width: 100%;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  .modal-close {
    display: none;
  }
  .btn-close {
    opacity: 0;
    left: auto;
    right: -6px;
    top: 1px;
    position: absolute;
    transform: translateX(-50%);
    color: #fff;
    font-size: 30px;
    cursor: pointer;
  }

  .result-flag {
    width: 120px;
    height: 120px;
    margin: -80px auto 20px;
    background: url(${require('../images/img-result-win.png')}) no-repeat center /
      contain;
    &-same {
      background-image: url(${require('../images/img-room-same.png')});
    }
    &-fail {
      background-image: url(${require('../images/bg-result-fail.png')});
    }
  }
  .pk-user {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;
    margin-top: -8px;
    &-item {
      width: 120px;
      color: #fff;
      text-align: center;
    }
  }
  .avatar {
    width: 80px;
    height: 80px;
    border-radius: 100%;
  }
  .nick {
    display: block;
    font-size: 16px;
    max-width: 100%;
    margin: 4px auto 0;
  }
  .value {
    font-size: 14px;
    font-weight: bold;
  }
`;

export default PopupResult;
